
export const taskType = (val, small = false) => {
    let arr = [
        { val:'single_choice',name:'单项选择题' },
        { val:'multiple_choice',name:'多项选择题' },
        { val:'jud_question',name:'判断题' },
        { val:'fill',name:'填空题' },
        { val:'answer',name:'简答题' },
        { val:'material',name:'材料题' },
    ]
    if(val){
        return arr.filter(el=>el.val == val)[0].name || arr.filter(el=>el.name == val).val
    }else{
        if(small){
            return [
                { val:'single_choice',name:'单项选择题' },
                { val:'multiple_choice',name:'多项选择题' },
                { val:'jud_question',name:'判断题' },
                { val:'fill',name:'填空题' },
                { val:'answer',name:'简答题' },
            ]
        }else{
            return arr
        }
    }
}

export const classB = [
    {
        name: '升学历',
        id:1
    },{
        name:'考证书',
        id:2
    },{
        name:'其他类',
        id:3
    }
]

export const num_zn=['一','二','三','四','五','六','七','八','九','十','十一','十二','十三','十四']

